/* eslint-disable */
// Utility helpers for message notifications (sound + browser banner).
// Falls back silently when the browser blocks or disables the Notification API.

// A tiny beep generated via WebAudio so we don't ship an audio asset.
let _ctx = null;
const getCtx = () => {
  try {
    if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
    return _ctx;
  } catch {
    return null;
  }
};

export const playMessageBeep = () => {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    // Two-tone "ding"
    const now = ctx.currentTime;
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.connect(gain1); gain1.connect(ctx.destination);
    osc1.frequency.setValueAtTime(880, now); // A5
    gain1.gain.setValueAtTime(0, now);
    gain1.gain.linearRampToValueAtTime(0.18, now + 0.01);
    gain1.gain.exponentialRampToValueAtTime(0.0001, now + 0.25);
    osc1.start(now); osc1.stop(now + 0.26);

    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.connect(gain2); gain2.connect(ctx.destination);
    osc2.frequency.setValueAtTime(1320, now + 0.14); // E6
    gain2.gain.setValueAtTime(0, now + 0.14);
    gain2.gain.linearRampToValueAtTime(0.18, now + 0.15);
    gain2.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);
    osc2.start(now + 0.14); osc2.stop(now + 0.44);
  } catch {
    // Audio blocked — ignore
  }
};

export const ensureNotificationPermission = async () => {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const res = await Notification.requestPermission();
    return res;
  } catch {
    return 'denied';
  }
};

export const showMessageBanner = ({ title, body, icon, onClick }) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return null;
  if (document.visibilityState === 'visible' && document.hasFocus()) return null; // Skip if tab is front-and-center
  try {
    const n = new Notification(title || 'New message', {
      body: (body || '').slice(0, 200),
      icon: icon || '/favicon.ico',
      tag: 'kk-chat',
      renotify: true,
    });
    if (onClick) n.onclick = () => { window.focus(); onClick(); n.close(); };
    setTimeout(() => n.close(), 7000);
    return n;
  } catch {
    return null;
  }
};

export const notifyNewMessage = ({ title, body, onClick }) => {
  playMessageBeep();
  showMessageBanner({ title, body, onClick });
};
